function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import ParagraphAndAssetColumnsComponent from "/components/core/paragraph-and-asset-columns/paragraph-and-asset-columns-component";
class TextAndAssetComponent extends PureComponent {
    render() {
        const { marginTop } = this.props;
        return /*#__PURE__*/ _jsx("div", {
            className: "paragaph-and-asset-component",
            style: {
                marginTop
            },
            children: /*#__PURE__*/ _jsx(ParagraphAndAssetColumnsComponent, _object_spread({}, this.props))
        });
    }
    constructor(props){
        super(props);
    }
}
export { TextAndAssetComponent as default };
TextAndAssetComponent.defaultProps = {
    content: {
        topic: {
            text: "Simple and intuitive",
            color: "brand-blue"
        },
        title: "Easy onboarding, fast adoption",
        body: [
            "Getting your team onboard recuires sending an invatation, and that’s it! It’s so visual and easy to use your teammates will get hooked immediatly."
        ],
        bottomLink: {
            href: "/",
            text: "See all features"
        }
    },
    asset: {
        side: "right",
        shadow: false
    }
};
